import * as React from 'react';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ClearButton.css';

interface IClearButtonProps {
  onClick(): void;
}

export const ClearButton: React.FC<IClearButtonProps> = ({ onClick }) => {
  return (
    <button className={styles['button']} onClick={onClick} aria-label="Очистить" type="button">
      <IconActionClose12 />
    </button>
  );
};
